import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import MainButton from "../../common/buttons/mainButton/MainButton";
import {
  Player,
  ControlBar,
  PlayToggle,
  VolumeMenuButton,
  BigPlayButton,
} from "video-react";
import HeaderVideoThumbnail from "../../../assets/images/static/videoThumbnail.svg";
import HeaderFloatingCardBeforeLogin from "./headerFloatingCard/headerFloatingCardBeforeLogin/HeaderFloatingCardBeforeLogin";
import HeaderFloatingCardAfterLogin from "./headerFloatingCard/headerFloatingCardAfterLogin/HeaderFloatingCardAfterLogin";
import HeaderFloatingCardAfterPayment from "./headerFloatingCard/headerFloatingCardAfterPayment/HeaderFloatingCardAfterPayment";
import {
  getRegisteredStatistics,
  getStatistics,
} from "../../../services/home.service";
import { countinueYourEducation } from "../../../services/student.service";
import { useSelector } from "react-redux";
import { Fade } from "react-reveal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import environment from "../../../environment";

const Header = ({ status, headerData, features }) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const { i18n, t } = useTranslation();
  const isAr = i18n.language === "ar";

  // get data from api
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState();
  const isLogin = localStorage.getItem(environment.TOKEN_KEY);
  const [isCountinueEducationLoading, setIsCountinueEducationLoading] =
    useState(false);
  const [countinueEducation, setCountinueEducation] = useState();

  const getData = async () => {
    setIsLoading(true);
    const response = isLogin
      ? await getRegisteredStatistics()
      : await getStatistics();
    if (response?.status === 200) {
      setData(response?.data?.data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const ContinueEducation = async () => {
    setIsCountinueEducationLoading(true);
    const response = await countinueYourEducation();
    if (response?.status === 200) {
      setCountinueEducation(response?.data?.data);
      setIsCountinueEducationLoading(false);
    } else {
      setIsCountinueEducationLoading(false);
    }
  };

  useEffect(() => {
    getData();
    isLogin && ContinueEducation();
  }, []);

  return (
    <Styles>
      <header>
        <Container>
          <Row className="header-data">
            <Col lg={6} className="header-content">
              {i18n.language == "ar" ? (
                <Fade right>
                  <h1 className="header-title mb-4">{t("title")}</h1>
                  <h2 className="header-title mb-3">{t("subtitle")}</h2>
                  <p className="header-description">{t("description1")}</p>
                  <p className="header-description">{t("description2")}</p>
                  <MainButton
                    buttonText={
                      Resource?.browse_courses
                        ? Resource?.browse_courses
                        : t("home.header.browse_courses")
                    }
                    buttonClick={() => {
                      navigate("/courses");
                    }}
                  />
                </Fade>
              ) : (
                <Fade left>
                  <h1 className="header-title mb-4">{t("title")}</h1>
                  <h2 className="header-title mb-3">{t("subtitle")}</h2>
                  <p className="header-description">{t("description1")}</p>
                  <p className="header-description">{t("description2")}</p>
                  <MainButton
                    buttonText={
                      Resource?.browse_courses
                        ? Resource?.browse_courses
                        : t("home.header.browse_courses")
                    }
                    buttonClick={() => {
                      navigate("/courses");
                    }}
                  />
                </Fade>
              )}
            </Col>
            <Col lg={6} className="header-video">
              {isAr ? (
                <Fade left>
                  {headerData?.IsHomeScreenIntroVideo &&
                  headerData?.IsHomeScreenIntroVideo?.toLowerCase() ===
                    "false" ? (
                    <div className="img-container">
                      <img
                        src={headerData?.HomeScreenIntroFile}
                        alt="header img"
                      />
                    </div>
                  ) : (
                    <Player
                      src={headerData?.HomeScreenIntroFile}
                      poster={headerData?.HomeScreenIntroVideoThumbnailFile}
                    >
                      <BigPlayButton position="center" />
                      <ControlBar>
                        <PlayToggle />
                        <VolumeMenuButton />
                      </ControlBar>
                    </Player>
                  )}
                </Fade>
              ) : (
                <Fade right>
                  {headerData?.IsHomeScreenIntroVideo &&
                  headerData?.IsHomeScreenIntroVideo?.toLowerCase() ===
                    "false" ? (
                    <div className="img-container">
                      <img
                        src={headerData?.HomeScreenIntroFile}
                        alt="header img"
                      />
                    </div>
                  ) : (
                    <Player
                      src={headerData?.HomeScreenIntroFile}
                      poster={headerData?.HomeScreenIntroVideoThumbnailFile}
                    >
                      <BigPlayButton position="center" />
                      <ControlBar>
                        <PlayToggle />
                        <VolumeMenuButton />
                      </ControlBar>
                    </Player>
                  )}
                </Fade>
              )}
            </Col>
          </Row>
          {isLogin ? (
            <>
              <HeaderFloatingCardAfterLogin
                coursesCount={data?.coursesCount}
                activitiesCount={data?.eventsCount}
                pointsCount={data?.pointsCount}
              />
            </>
          ) : (
            <HeaderFloatingCardBeforeLogin
              isLoading={isLoading}
              studentsCount={data?.studentsCount}
              lecturesCount={data?.sessionsCount}
              activitiesCount={data?.eventsCount}
            />
          )}
          {/* {(status == 4 || !status) && (
            <HeaderFloatingCardBeforeLogin
              isLoading={isLoading}
              studentsCount={data?.num_of_students}
              lecturesCount={data?.num_of_lessons}
              activitiesCount={data?.num_of_assignment}
            />
          )}
          {(status == 1 || status == 3) && (
            <HeaderFloatingCardAfterLogin
              coursesCount={data?.num_of_courses}
              activitiesCount={data?.num_of_activities}
              pointsCount={250}
            />
          )}
          {(status == 2 || status == 5) && (
            <HeaderFloatingCardAfterPayment
              isLoading={isCountinueEducationLoading}
              courseImg={countinueEducation?.image}
              courseName={countinueEducation?.category_title}
              courseUrl={countinueEducation?.category_slug}
              courseProgress={countinueEducation?.lesson_duration}
            />
          )} */}
        </Container>
      </header>
      <div className="continue-education">
        {isLogin && (
          <HeaderFloatingCardAfterPayment
            isLoading={isCountinueEducationLoading}
            courseImg={countinueEducation?.image}
            courseName={countinueEducation?.localizedName}
            courseUrl={countinueEducation?.id}
            courseType={countinueEducation?.type}
            // courseProgress={countinueEducation?.lesson_duration}
          />
        )}
      </div>
    </Styles>
  );
};

export default Header;
